import "../js/main";
import "../scss/general/styles.scss";



// WEBPACK FOOTER //
// ./src/entry/app.js